import { useMsal } from "@azure/msal-react";
import { useCallback } from "react";
import { clearPermissions } from "@/store/slices/permissionSlice";
import { useAppDispatch } from "@/store/hooks";

export const useLogout = (): { logout: () => Promise<void> } => {
  const { instance, accounts } = useMsal();
  const dispatch = useAppDispatch();

  const logout = useCallback(async (): Promise<void> => {
    const account = instance.getActiveAccount() ?? accounts[0];

    // Clear local auth state even if the MSAL redirect fails.
    dispatch(clearPermissions());

    try {
      Object.keys(localStorage).forEach((key) => {
        if (!key.toLowerCase().startsWith("msal")) {
          localStorage.removeItem(key);
        }
      });
      await instance.logoutRedirect({
        account: account ?? undefined,
        postLogoutRedirectUri: window.location.origin,
      });
    } catch {
      // Fallback to a hard navigation to avoid trapping the user in a non-dismissible UI.
      window.location.assign(window.location.origin);
    }
  }, [accounts, dispatch, instance]);

  return { logout };
};
